module.exports = __webpack_public_path__ + "media/images/icons/calendar-disable-ebb146afb7810c646d8ba3cc0dfa82df.svg";